import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
	root: {
		backgroundColor: "orange",
		paddingTop: "30vh",
		paddingLeft: theme.spacing.unit,
		paddingRight: theme.spacing.unit,
		minHeight: "100vh"
	}
});

class NoMatch extends Component {
	// componentDidMount() {
	// }

	// componentWillUnmount() {
	// }

	render() {
		let {classes} = this.props;
		return (
			<Paper className={classes.root}>
				<Grid container direction="column" alignItems="center" spacing={16}>
					<Grid item>
						<Typography variant="h4">Whoops!</Typography>
					</Grid>
					<Grid item>
						<Typography variant="subtitle1">Nothing to see; nothing to say.</Typography>
					</Grid>
					<Grid item>
						<Link className="primary" to="/">
							<Button
								color="primary"
								ga-on="click"
								ga-event-category="WebApp"
								ga-event-action="Button Pressed"
								ga-event-label="Restart">
								Restart
							</Button>
						</Link>
					</Grid>
					<Grid item>
						<Typography variant="caption">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</Typography>
					</Grid>
				</Grid>
			</Paper>
		);
	}
}

NoMatch.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NoMatch);
